/**
 * Product names in the authoritative Shine Auth rights contract. An installed
 * interface may expose only a subset; its PRODUCT_ORDER still controls grants.
 */
export const RIGHTS_PRODUCT_CATALOG: readonly string[] = [
    'Shine AI',
    'Shine Connect',
    'Shine Performance',
    'Shine Enrich',
    'Shine Translations',
    'Shine Webinars',
];
